/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Contract,
  ContractFactory,
  ContractTransactionResponse,
  Interface,
} from "ethers";
import type {
  Signer,
  AddressLike,
  ContractDeployTransaction,
  ContractRunner,
} from "ethers";
import type { NonPayableOverrides } from "../../common";
import type {
  AttesterResolver,
  AttesterResolverInterface,
} from "../../contracts/AttesterResolver";

const _abi = [
  {
    inputs: [
      {
        internalType: "contract IEAS",
        name: "eas",
        type: "address",
      },
      {
        internalType: "address",
        name: "targetAttester",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "AccessDenied",
    type: "error",
  },
  {
    inputs: [],
    name: "InsufficientValue",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidEAS",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidLength",
    type: "error",
  },
  {
    inputs: [],
    name: "NotPayable",
    type: "error",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "bytes32",
            name: "uid",
            type: "bytes32",
          },
          {
            internalType: "bytes32",
            name: "schema",
            type: "bytes32",
          },
          {
            internalType: "uint64",
            name: "time",
            type: "uint64",
          },
          {
            internalType: "uint64",
            name: "expirationTime",
            type: "uint64",
          },
          {
            internalType: "uint64",
            name: "revocationTime",
            type: "uint64",
          },
          {
            internalType: "bytes32",
            name: "refUID",
            type: "bytes32",
          },
          {
            internalType: "address",
            name: "recipient",
            type: "address",
          },
          {
            internalType: "address",
            name: "attester",
            type: "address",
          },
          {
            internalType: "bool",
            name: "revocable",
            type: "bool",
          },
          {
            internalType: "bytes",
            name: "data",
            type: "bytes",
          },
        ],
        internalType: "struct Attestation",
        name: "attestation",
        type: "tuple",
      },
    ],
    name: "attest",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "isPayable",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "bytes32",
            name: "uid",
            type: "bytes32",
          },
          {
            internalType: "bytes32",
            name: "schema",
            type: "bytes32",
          },
          {
            internalType: "uint64",
            name: "time",
            type: "uint64",
          },
          {
            internalType: "uint64",
            name: "expirationTime",
            type: "uint64",
          },
          {
            internalType: "uint64",
            name: "revocationTime",
            type: "uint64",
          },
          {
            internalType: "bytes32",
            name: "refUID",
            type: "bytes32",
          },
          {
            internalType: "address",
            name: "recipient",
            type: "address",
          },
          {
            internalType: "address",
            name: "attester",
            type: "address",
          },
          {
            internalType: "bool",
            name: "revocable",
            type: "bool",
          },
          {
            internalType: "bytes",
            name: "data",
            type: "bytes",
          },
        ],
        internalType: "struct Attestation[]",
        name: "attestations",
        type: "tuple[]",
      },
      {
        internalType: "uint256[]",
        name: "values",
        type: "uint256[]",
      },
    ],
    name: "multiAttest",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "bytes32",
            name: "uid",
            type: "bytes32",
          },
          {
            internalType: "bytes32",
            name: "schema",
            type: "bytes32",
          },
          {
            internalType: "uint64",
            name: "time",
            type: "uint64",
          },
          {
            internalType: "uint64",
            name: "expirationTime",
            type: "uint64",
          },
          {
            internalType: "uint64",
            name: "revocationTime",
            type: "uint64",
          },
          {
            internalType: "bytes32",
            name: "refUID",
            type: "bytes32",
          },
          {
            internalType: "address",
            name: "recipient",
            type: "address",
          },
          {
            internalType: "address",
            name: "attester",
            type: "address",
          },
          {
            internalType: "bool",
            name: "revocable",
            type: "bool",
          },
          {
            internalType: "bytes",
            name: "data",
            type: "bytes",
          },
        ],
        internalType: "struct Attestation[]",
        name: "attestations",
        type: "tuple[]",
      },
      {
        internalType: "uint256[]",
        name: "values",
        type: "uint256[]",
      },
    ],
    name: "multiRevoke",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "bytes32",
            name: "uid",
            type: "bytes32",
          },
          {
            internalType: "bytes32",
            name: "schema",
            type: "bytes32",
          },
          {
            internalType: "uint64",
            name: "time",
            type: "uint64",
          },
          {
            internalType: "uint64",
            name: "expirationTime",
            type: "uint64",
          },
          {
            internalType: "uint64",
            name: "revocationTime",
            type: "uint64",
          },
          {
            internalType: "bytes32",
            name: "refUID",
            type: "bytes32",
          },
          {
            internalType: "address",
            name: "recipient",
            type: "address",
          },
          {
            internalType: "address",
            name: "attester",
            type: "address",
          },
          {
            internalType: "bool",
            name: "revocable",
            type: "bool",
          },
          {
            internalType: "bytes",
            name: "data",
            type: "bytes",
          },
        ],
        internalType: "struct Attestation",
        name: "attestation",
        type: "tuple",
      },
    ],
    name: "revoke",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "version",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
] as const;

const _bytecode =
  "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";

type AttesterResolverConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: AttesterResolverConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class AttesterResolver__factory extends ContractFactory {
  constructor(...args: AttesterResolverConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override getDeployTransaction(
    eas: AddressLike,
    targetAttester: AddressLike,
    overrides?: NonPayableOverrides & { from?: string }
  ): Promise<ContractDeployTransaction> {
    return super.getDeployTransaction(eas, targetAttester, overrides || {});
  }
  override deploy(
    eas: AddressLike,
    targetAttester: AddressLike,
    overrides?: NonPayableOverrides & { from?: string }
  ) {
    return super.deploy(eas, targetAttester, overrides || {}) as Promise<
      AttesterResolver & {
        deploymentTransaction(): ContractTransactionResponse;
      }
    >;
  }
  override connect(runner: ContractRunner | null): AttesterResolver__factory {
    return super.connect(runner) as AttesterResolver__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): AttesterResolverInterface {
    return new Interface(_abi) as AttesterResolverInterface;
  }
  static connect(
    address: string,
    runner?: ContractRunner | null
  ): AttesterResolver {
    return new Contract(address, _abi, runner) as unknown as AttesterResolver;
  }
}
